// client/src/championIcons/index.ts

/**
 * Auto-generated index of champion icon PNGs.
 * Maps each filename (without “.png”) to its imported URL.
 */

import icon__1 from "./-1.png";
import icon_107 from "./107.png";
import icon_119 from "./119.png";
import icon_133 from "./133.png";
import icon_15 from "./15.png";
import icon_17 from "./17.png";
import icon_21 from "./21.png";
import icon_236 from "./236.png";
import icon_266 from "./266.png";
import icon_32 from "./32.png";
import icon_39 from "./39.png";
import icon_429 from "./429.png";
import icon_50 from "./50.png";
import icon_55 from "./55.png";
import icon_62 from "./62.png";
import icon_74 from "./74.png";
import icon_80 from "./80.png";
import icon_876 from "./876.png";
import icon_901 from "./901.png";

import icon_1 from "./1.png";
import icon_11 from "./11.png";
import icon_12 from "./12.png";
import icon_134 from "./134.png";
import icon_150 from "./150.png";
import icon_18 from "./18.png";
import icon_22 from "./22.png";
import icon_238 from "./238.png";
import icon_267 from "./267.png";
import icon_33 from "./33.png";
import icon_4 from "./4.png";
import icon_43 from "./43.png";
import icon_51 from "./51.png";
import icon_555 from "./555.png";
import icon_63 from "./63.png";
import icon_75 from "./75.png";
import icon_800 from "./800.png";
import icon_887 from "./887.png";
import icon_902 from "./902.png";

import icon_10 from "./10.png";
import icon_110 from "./110.png";
import icon_120 from "./120.png";
import icon_136 from "./136.png";
import icon_154 from "./154.png";
import icon_19 from "./19.png";
import icon_221 from "./221.png";
import icon_24 from "./24.png";
import icon_268 from "./268.png";
import icon_34 from "./34.png";
import icon_40 from "./40.png";
import icon_432 from "./432.png";
import icon_516 from "./516.png";
import icon_56 from "./56.png";
import icon_64 from "./64.png";
import icon_76 from "./76.png";
import icon_81 from "./81.png";
import icon_888 from "./888.png";
import icon_91 from "./91.png";

import icon_101 from "./101.png";
import icon_111 from "./111.png";
import icon_121 from "./121.png";
import icon_14 from "./14.png";
import icon_157 from "./157.png";
import icon_2 from "./2.png";
import icon_222 from "./222.png";
import icon_240 from "./240.png";
import icon_27 from "./27.png";
import icon_35 from "./35.png";
import icon_41 from "./41.png";
import icon_44 from "./44.png";
import icon_517 from "./517.png";
import icon_57 from "./57.png";
import icon_67 from "./67.png";
import icon_77 from "./77.png";
import icon_82 from "./82.png";
import icon_89 from "./89.png";
import icon_910 from "./910.png";

import icon_102 from "./102.png";
import icon_112 from "./112.png";
import icon_122 from "./122.png";
import icon_141 from "./141.png";
import icon_16 from "./16.png";
import icon_20 from "./20.png";
import icon_223 from "./223.png";
import icon_245 from "./245.png";
import icon_28 from "./28.png";
import icon_350 from "./350.png";
import icon_412 from "./412.png";
import icon_45 from "./45.png";
import icon_518 from "./518.png";
import icon_58 from "./58.png";
import icon_68 from "./68.png";
import icon_78 from "./78.png";
import icon_84 from "./84.png";
import icon_895 from "./895.png";
import icon_92 from "./92.png";

import icon_103 from "./103.png";
import icon_113 from "./113.png";
import icon_126 from "./126.png";
import icon_142 from "./142.png";
import icon_161 from "./161.png";
import icon_200 from "./200.png";
import icon_23 from "./23.png";
import icon_246 from "./246.png";
import icon_29 from "./29.png";
import icon_360 from "./360.png";
import icon_420 from "./420.png";
import icon_497 from "./497.png";
import icon_526 from "./526.png";
import icon_6 from "./6.png";
import icon_7 from "./7.png";
import icon_79 from "./79.png";
import icon_85 from "./85.png";
import icon_897 from "./897.png";
import icon_96 from "./96.png";

import icon_104 from "./104.png";
import icon_114 from "./114.png";
import icon_127 from "./127.png";
import icon_143 from "./143.png";
import icon_163 from "./163.png";
import icon_201 from "./201.png";
import icon_233 from "./233.png";
import icon_25 from "./25.png";
import icon_3 from "./3.png";
import icon_421 from "./421.png";
import icon_498 from "./498.png";
import icon_53 from "./53.png";
import icon_60 from "./60.png";
import icon_711 from "./711.png";
import icon_799 from "./799.png";
import icon_86 from "./86.png";
import icon_9 from "./9.png";
import icon_98 from "./98.png";

import icon_106 from "./106.png";
import icon_117 from "./117.png";
import icon_131 from "./131.png";
import icon_147 from "./147.png";
import icon_166 from "./166.png";
import icon_203 from "./203.png";
import icon_235 from "./235.png";
import icon_26 from "./26.png";
import icon_31 from "./31.png";
import icon_38 from "./38.png";
import icon_427 from "./427.png";
import icon_5 from "./5.png";
import icon_54 from "./54.png";
import icon_61 from "./61.png";
import icon_72 from "./72.png";
import icon_8 from "./8.png";
import icon_875 from "./875.png";
import icon_90 from "./90.png";
import icon_99 from "./99.png";

const championIcons: Record<string, string> = {
  "-1": icon__1,
  "107": icon_107,
  "119": icon_119,
  "133": icon_133,
  "15": icon_15,
  "17": icon_17,
  "21": icon_21,
  "236": icon_236,
  "266": icon_266,
  "32": icon_32,
  "39": icon_39,
  "429": icon_429,
  "50": icon_50,
  "55": icon_55,
  "62": icon_62,
  "74": icon_74,
  "80": icon_80,
  "876": icon_876,
  "901": icon_901,

  "1": icon_1,
  "11": icon_11,
  "12": icon_12,
  "134": icon_134,
  "150": icon_150,
  "18": icon_18,
  "22": icon_22,
  "238": icon_238,
  "267": icon_267,
  "33": icon_33,
  "4": icon_4,
  "43": icon_43,
  "51": icon_51,
  "555": icon_555,
  "63": icon_63,
  "75": icon_75,
  "800": icon_800,
  "887": icon_887,
  "902": icon_902,

  "10": icon_10,
  "110": icon_110,
  "120": icon_120,
  "136": icon_136,
  "154": icon_154,
  "19": icon_19,
  "221": icon_221,
  "24": icon_24,
  "268": icon_268,
  "34": icon_34,
  "40": icon_40,
  "432": icon_432,
  "516": icon_516,
  "56": icon_56,
  "64": icon_64,
  "76": icon_76,
  "81": icon_81,
  "888": icon_888,
  "91": icon_91,

  "101": icon_101,
  "111": icon_111,
  "121": icon_121,
  "14": icon_14,
  "157": icon_157,
  "2": icon_2,
  "222": icon_222,
  "240": icon_240,
  "27": icon_27,
  "35": icon_35,
  "41": icon_41,
  "44": icon_44,
  "517": icon_517,
  "57": icon_57,
  "67": icon_67,
  "77": icon_77,
  "82": icon_82,
  "89": icon_89,
  "910": icon_910,

  "102": icon_102,
  "112": icon_112,
  "122": icon_122,
  "141": icon_141,
  "16": icon_16,
  "20": icon_20,
  "223": icon_223,
  "245": icon_245,
  "28": icon_28,
  "350": icon_350,
  "412": icon_412,
  "45": icon_45,
  "518": icon_518,
  "58": icon_58,
  "68": icon_68,
  "78": icon_78,
  "84": icon_84,
  "895": icon_895,
  "92": icon_92,

  "103": icon_103,
  "113": icon_113,
  "126": icon_126,
  "142": icon_142,
  "161": icon_161,
  "200": icon_200,
  "23": icon_23,
  "246": icon_246,
  "29": icon_29,
  "360": icon_360,
  "420": icon_420,
  "497": icon_497,
  "526": icon_526,
  "6": icon_6,
  "7": icon_7,
  "79": icon_79,
  "85": icon_85,
  "897": icon_897,
  "96": icon_96,

  "104": icon_104,
  "114": icon_114,
  "127": icon_127,
  "143": icon_143,
  "163": icon_163,
  "201": icon_201,
  "233": icon_233,
  "25": icon_25,
  "3": icon_3,
  "421": icon_421,
  "498": icon_498,
  "53": icon_53,
  "60": icon_60,
  "711": icon_711,
  "799": icon_799,
  "86": icon_86,
  "9": icon_9,
  "98": icon_98,

  "106": icon_106,
  "117": icon_117,
  "131": icon_131,
  "147": icon_147,
  "166": icon_166,
  "203": icon_203,
  "235": icon_235,
  "26": icon_26,
  "31": icon_31,
  "38": icon_38,
  "427": icon_427,
  "5": icon_5,
  "54": icon_54,
  "61": icon_61,
  "72": icon_72,
  "8": icon_8,
  "875": icon_875,
  "90": icon_90,
  "99": icon_99,
};

export default championIcons;